
import { Button } from "@/components/ui/button";
import { ArrowRight, RefreshCw } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface VerificationActionsProps {
  isLoading: boolean;
  isValidCode: boolean;
  onVerify: () => Promise<any>;
  onResendCode: () => Promise<any>;
  onBackToLogin: () => void;
}

export const VerificationActions = ({
  isLoading,
  isValidCode,
  onVerify,
  onResendCode,
  onBackToLogin
}: VerificationActionsProps) => {
  const { t } = useLanguage();
  
  return (
    <>
      <Button 
        type="submit" 
        className="w-full mt-6 group shadow-md bg-primary hover:bg-primary-dark"
        disabled={isLoading || !isValidCode}
      >
        {isLoading ? (
          t('verifying') || 'Verifying...'
        ) : (
          <span className="flex items-center gap-2">
            {t('verifyCode') || 'Verify Code'}
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        )}
      </Button>
      
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onBackToLogin}
          className="text-xs"
        >
          {t('backToLogin') || 'Back to Login'}
        </Button>
        
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onResendCode}
          disabled={isLoading}
          className="text-xs flex items-center gap-1"
        >
          <RefreshCw className="h-3 w-3" />
          {t('resendCode') || 'Resend Code'}
        </Button>
      </div>
    </>
  );
};
